import React from "react";
import { Button } from "../../components/Button/Button";
import { contact_info } from "../../constants/contact";
import "./Hero.css";

interface HeroModuleProps {
  on_request_hosting?: () => void;
}

export const HeroModule: React.FC<HeroModuleProps> = ({
  on_request_hosting,
}) => {
  return (
    <section className="hero" id="hosting">
      <div className="hero__background">
        <div className="hero__gradient" />
        <div className="hero__grid" />
        <div className="hero__glow" />
      </div>

      <div className="hero__content">
        <p className="hero__eyebrow">Launch faster without platform drag</p>
        <h1 className="hero__title">
          Your managed cloud home,
          <span className="hero__brand"> ready for production</span>
        </h1>
        <p className="hero__subtitle">
          Choose your trust boundary: hosted in our Toronto datacentre, or
          deployed inside your cloud account for maximum control and compliance.
        </p>
        <p className="hero__description">
          Bring any workload. We handle the platform and operations, with deep
          specialization in containers and Kubernetes.
        </p>

        <div className="hero__actions">
          <Button size="large" variant="primary" onClick={on_request_hosting}>
            Request Hosting
          </Button>
          <a
            className="hero__contact-link"
            href={`tel:${contact_info.phone_link}`}
          >
            Call {contact_info.phone_display}
          </a>
        </div>

        <div className="hero__stats">
          <div className="hero__stat">
            <span className="hero__stat-value">Uptime first</span>
            <span className="hero__stat-label">Service Discipline</span>
          </div>
          <div className="hero__stat">
            <span className="hero__stat-value">Datacentre + Cloud</span>
            <span className="hero__stat-label">Choice of venue</span>
          </div>
          <div className="hero__stat">
            <span className="hero__stat-value">Containers</span>
            <span className="hero__stat-label">Kubernetes ready</span>
          </div>
        </div>
        <div className="hero__contact">
          <p>
            Email{" "}
            <a href={`mailto:${contact_info.email}`}>{contact_info.email}</a> or
            call {contact_info.phone_display} to start.
          </p>
        </div>
      </div>
    </section>
  );
};

// Register the module
export default {
  id: "hero",
  name: "Hero",
  component: HeroModule,
  priority: 1,
  render: () => <HeroModule />,
};
